import EditTomSVideoPlayer from './blocks/edit'

import "./index.scss"
import React from 'react'
import { __ } from '@wordpress/i18n';
import {TextControl, TextareaControl, Button, Icon, PanelBody, PanelRow, ToggleControl, SelectControl, CheckboxControl} from "@wordpress/components"
import {InspectorControls, MediaUpload, MediaUploadCheck, BlockControls, AlignmentToolbar} from "@wordpress/block-editor"

var TomSVPIcon =  FromPHP.defaultImgUrl ? FromPHP.defaultImgUrl : ''
const TomSVideoPlayerIcon = () => (
    <Icon
        // icon={
        //     <svg t="1633442741459" className="toms-video-player-icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2094" width="24" height="24">
        //         <path d="M609.214496 57.524408a2361.040572 2361.040572 0 0 0-392.209124 19.653543 47.289448 47.289448 0 0 0-40.516535 38.79307 1246.578867 1246.578867 0 0 0 0 441.146446 47.319684 47.319684 0 0 0 40.516535 38.853542 2360.511438 2360.511438 0 0 0 313.746134 20.938582 2360.511438 2360.511438 0 0 0 313.700779-20.938582 47.289448 47.289448 0 0 0 40.486299-38.853542 1247.153355 1247.153355 0 0 0-0.045355-441.11621 47.319684 47.319684 0 0 0-40.516534-38.823306 2361.040572 2361.040572 0 0 0-235.162199-19.653543zM437.820484 211.744247a32.398109 32.398109 0 0 1 16.131024 3.91559l12.351495 6.274016v-0.166299l114.14173 57.494171 114.126611 57.539527-114.141729 57.494171-114.14173 57.50929v-0.604724l-12.336377 6.289134a32.398109 32.398109 0 0 1-47.773228-26.849764V242.524718a32.398109 32.398109 0 0 1 31.642204-30.780471z" fill="#FF0000" p-id="2095"></path><path d="M156.351515 661.795259a0.514016 0.514016 0 0 0-0.514016 0.514016v49.436219c0 0.287244 0.226772 0.498898 0.514016 0.498898h64.569447v226.953065c0 0.287244 0.226772 0.498898 0.514016 0.498898h86.022045a0.498898 0.498898 0 0 0 0.498898-0.498898v-15.617007a121.035588 121.035588 0 0 1-43.147086-92.477478 121.035588 121.035588 0 0 1 43.147086-92.658896v-26.199684h124.558107a0.498898 0.498898 0 0 0 0.498897-0.498898v-49.436219a0.514016 0.514016 0 0 0-0.498897-0.514016z m685.515574 0.272126v2.343307h7.317165v18.277795h2.79685v-18.277795h7.317165v-2.343307z m20.137322 0v20.621102h2.706142V664.59211l5.291338 14.120314h2.811968l5.321575-14.120314v18.096377h2.72126v-20.621102h-4.15748l-5.291339 14.029606-5.245984-14.029606zM696.037801 691.048802l-19.472126 12.049133v33.290078H481.028042c-0.257008 0-0.468661 0.196535-0.468661 0.453544V755.905493a121.035588 121.035588 0 0 1 26.320629 75.182361 121.035588 121.035588 0 0 1-26.320629 75.348659v27.605669c0 0.302362 0.226772 0.529134 0.498898 0.529134h58.219841a0.529134 0.529134 0 0 0 0.514015-0.529134v-147.945823h45.959054v98.358422c0 0.211654 0.166299 0.377953 0.377953 0.377953h45.308975a0.377953 0.377953 0 0 0 0.393071-0.377953v-98.358422h44.734487v61.757478l19.44189 12.034016h102.969446a0.453543 0.453543 0 0 1 0.453543 0.453543v80.262045a0.453543 0.453543 0 0 1-0.453543 0.453544h-80.277163a0.453543 0.453543 0 0 1-0.453544-0.453544V903.760608H676.565675V983.856354c0 0.257008 0.196535 0.453543 0.453544 0.453543h145.919996l16.705511-10.340787v-146.917792l-19.971023-12.366614H718.714966a0.453543 0.453543 0 0 1-0.453544-0.453543V733.984234a0.453543 0.453543 0 0 1 0.453544-0.453543h80.246927a0.453543 0.453543 0 0 1 0.453543 0.453543v36.842834h40.22929V691.502345a0.453543 0.453543 0 0 0-0.453543-0.453543z" opacity=".96" p-id="2096"></path><path d="M326.641904 747.182344a21.044409 21.044409 0 0 0-20.560629 20.001259v122.154328a21.044409 21.044409 0 0 0 31.03748 17.431181l8.012598-4.08189v0.393071l74.124092-37.341732 74.124093-37.341731-74.124093-37.356849-74.124092-37.341732v0.120945l-8.012598-4.08189a21.044409 21.044409 0 0 0-10.476851-2.539842z m41.574803 46.079999a9.070866 9.070866 0 0 1 4.505196 1.103622l3.462047 1.7537v-0.060472l31.974803 16.115905 31.974802 16.115905-31.974802 16.115905-31.974803 16.115905v-0.151181l-3.477165 1.753701a9.070866 9.070866 0 0 1-13.379527-7.528819v-52.701731a9.070866 9.070866 0 0 1 8.87433-8.617322z" fill="#FF0000" p-id="2097"></path>
        //     </svg>
        // }
        icon={
            <img src={ TomSVPIcon } style={{height: "24px", width: "auto"}} />
        }
    />
);

                
{/* Change the TomS Blocks Category Icon */
    ( function () {                   
        var TomSLogo =  FromPHP.defaultLogo ? FromPHP.defaultLogo : ''
        const TomSBlocksIcon = () => (
            <Icon
                // icon={
                //     <svg t="1633509965289" className="toms-blocks-icon" viewBox="0 0 1078 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2725" width="24" height="24">
                //         <path d="M9.872126 282.058576a0.755905 0.755905 0 0 0-0.755906 0.755905v72.94488c0 0.423307 0.347717 0.755905 0.755906 0.755906h95.274328v334.866133c0 0.408189 0.332598 0.740787 0.755906 0.740788H232.818892a0.755905 0.755905 0 0 0 0.755905-0.755906v-23.039999a178.590232 178.590232 0 0 1-63.66236-136.45606 178.590232 178.590232 0 0 1 63.647242-136.697949v-38.657007h183.775744a0.755905 0.755905 0 0 0 0.755905-0.755906v-72.94488a0.755905 0.755905 0 0 0-0.755905-0.755905z m1011.47714 0.423307v3.462047h10.794331v26.95559h4.142362v-26.95559h10.79433v-3.477165z m29.707086 0v30.417637h3.991181V286.18582l7.831181 20.862991h4.15748l7.831181-20.862991v26.7137h4.021417v-30.417637h-6.137952l-7.800945 20.696692-7.75559-20.71181z m-244.883143 42.738896l-28.724409 17.794016v49.103621H488.919673c-0.377953 0-0.695433 0.302362-0.695433 0.650078V420.948651a178.590232 178.590232 0 0 1 38.853542 110.921572 178.590232 178.590232 0 0 1-38.853542 111.17858v40.758424c0 0.423307 0.332598 0.755905 0.755905 0.755906h85.901101a0.755905 0.755905 0 0 0 0.755905-0.755906v-218.305506h67.804723v145.118736c0 0.302362 0.24189 0.574488 0.55937 0.574489h66.852282c0.302362 0 0.574488-0.257008 0.574488-0.574489V465.486603h65.99055v91.116848l28.70929 17.748661H958.034622c0.377953 0 0.680315 0.302362 0.680315 0.680315v118.435272c0 0.362835-0.302362 0.680315-0.680315 0.680315h-118.420154a0.680315 0.680315 0 0 1-0.680315-0.680315v-54.364723h-61.515589V757.281241c0 0.362835 0.302362 0.665197 0.680314 0.665197h215.327239l24.642519-15.269291V525.89857l-29.480314-18.232441h-148.973854a0.665197 0.665197 0 0 1-0.680315-0.680315v-118.420154c0-0.377953 0.302362-0.680315 0.680315-0.680315h118.420154c0.377953 0 0.680315 0.302362 0.680315 0.680315V442.915265h59.353699v-117.014171a0.680315 0.680315 0 0 0-0.680315-0.680315z" opacity=".96" p-id="2726"></path><path d="M267.363773 425.484084a26.910236 26.910236 0 0 0-26.275275 25.564724v156.215429a26.910236 26.910236 0 0 0 39.66992 22.284094l10.250079-5.215748v0.498898l94.790549-47.758109 94.77543-47.742991-94.790548-47.773227-94.775431-47.75811v0.151182l-10.250079-5.230866a26.910236 26.910236 0 0 0-13.394645-3.235276zM320.503929 484.38424a11.610708 11.610708 0 0 1 5.775118 1.405984l4.429606 2.267717v-0.090709l40.879369 20.605984 40.909606 20.621102-40.909606 20.590865-40.879369 20.605984v-0.196535l-4.429606 2.267716a11.610708 11.610708 0 0 1-17.1137-9.645354v-67.381416a11.610708 11.610708 0 0 1 11.338582-11.03622z" fill="#FF0000" p-id="2727"></path>
                //     </svg>
                // }
                icon={
                    <img src={ TomSLogo } style={{height: "14px", width: "auto"}} />
                }
            />
        );
        wp.blocks.updateCategory( 'tomsneddon', { icon: TomSBlocksIcon } );
    } )()
}

wp.blocks.registerBlockType("tomsneddon-video-player/toms-video-player", {
    title: __("TomS Video Player", "toms-video-player"),
    icon: TomSVideoPlayerIcon,
    category: "tomsneddon",
    attributes: {
        videoBlock: {
            type: 'boolean',
            default: true
        },
        videoAlignment: {
            type: "string", 
            default: "none"
        },
        controls: {
            type: 'boolean',
            default: true
        },
        autoPictureInPicture: {
            type: 'boolean',
            default: undefined
        },
        disablePictureInPicture: {
            type: 'boolean',
            default: true
        },
        autoPlay: {
            type: 'boolean',
            default: undefined
        },
        loop: {
            type: 'boolean',
            default: undefined
        },
        muted: {
            type: 'boolean',
            default: false
        },
        playsInline: {
            type: 'boolean',
            default: false
        },
        noDownload: {
            type: 'boolean',
            default: true
        },
        noFullscreen: {
            type: 'boolean',
            default: false
        },
        noRemotePlayback: {
            type: 'boolean',
            default: false
        },
        preload: {
            type: 'string',
            default: 'metadata'
        },
        disableSaveVideoAs: {
            type: 'boolean',
            default: true
        },
        posterLock:{
            type: 'boolean',
            default: false
        },
        posterImgId: {
            type: 'number',
            default: 0
        },
        posterImg: {
            type: 'string',
            default: ''
        },
        videoRemark: {
            type: 'string'
        },
        videoId: {
            type: 'number',
            default: 0
        },
        videoSource: {
            type: 'string',
            default: ''
        },
        videoType:{
            type: 'string',
            default: ''
        },
        videoWidth: {
            type: 'number'
        },
        videoHeight: {
            type: 'number'
        },
        preview: {
            type: 'boolean',
            default: false
        },
        videoSize: {
            type: 'boolean',
            default: false
        },
        disabledResponsiveSize: {
            type: 'boolean',
            default: false
        },
        sourceLock:{
            type: 'boolean',
            default: false
        },
        source: {
            type: 'array',
            default: ['']
        },
        mimeType: {
            type: 'array',
            default: ['']
        }
    },
    description: __("Simply protect your videos from being downloaded 'Directly'.", "toms-video-player"),
    // example: {
    //     attributes: {
    //         videoTitle: __("TomS Video Player", "toms-video-player"),
    //         videoSource: ['']
    //     }
    // },
    edit: function (props) {
        return(
            <>
                <EditTomSVideoPlayer {...props} />
            </>
        )
    },
    save: function (props) {
        return null
    }
})